import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import Validate from '../../../../../components/Validation/Validate';
import { checkDateOnly, required } from '../../../../../utils/validation/validator';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import CurrencySelector from '../../../components/CurrencySelector';
import OptionsContainer from '../../../components/OptionsContainer';
import FlexBox from '../../../../../components/FlexBox';

export class AdditionalItem extends React.Component {
  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  onChangeResetReceived = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    item.howMuchReceivedReimbursement = '';
    item.currentReceivedReimbursement = '';
    item.fromWhomReceivedReimbursement = '';
    item.dateReimbursementReceived = '';
    this.change(item);
  };

  handleDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const { item } = this.props;
    const {
      isDelayed,
      disabled,
      validatorGroup,
      validationCounter,
      removable,
    } = this.props;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className="form-group col-auto">
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          {!isDelayed && (
            <div className="form-group col-auto">
              <PageSectionHeader>
                <FormattedMessage {...messages.itemWithIdx} values={{ idx: this.props.index + 1 }} />
              </PageSectionHeader>
            </div>
          )}
          {isDelayed && (
            <div className="form-group col-auto">
              <PageSectionHeader>
                <FormattedMessage {...messages.delayedLuggageExpenseWithIdx} values={{ idx: this.props.index + 1 }} />
              </PageSectionHeader>
            </div>
          )}
        </div>
        <div className="row">
          <div className="form-group col-md-7 col-sm-7">
            <PageSectionHeader>
              <FormattedMessage {...messages.itemDescription} />
            </PageSectionHeader>
            <Textbox
              disabled={disabled}
              name="itemDescription"
              type="text"
              onChange={this.onChange('itemDescription')}
              value={item.itemDescription}
            />
          </div>
          <div className="form-group col-md-5 col-sm-5">
                <Validate
                  name="dateOfLoss"
                  validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                  group={validatorGroup}
                  validators={[required, checkDateOnly]}
                  addValidatorToGroup={validatorGroup.addValidatorToGroup}
                  validChangeInGroup={validatorGroup.validChangeInGroup}
                  validationCounter={validationCounter}
                  defaultValue={item.dateOfLoss}
                  fieldName={messages.dateOfLoss}
                >
                  <DatePicker
                    disabled={disabled}
                    name="dateOfLoss"
                    type="text"
                    onDayChange={this.handleDayChange('dateOfLoss')}
                    value={item.dateOfLoss}
                    placeholder="dd/mm/yyyy"
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateOfLoss}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={messages.dateOfLoss}
                    />
                  </ErrorMessage>
                </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-7 col-sm-7">
            <PageSectionHeader>
              <FormattedMessage {...messages.estimatedValue} />
            </PageSectionHeader>
            <Textbox
              disabled={disabled}
              name="estimatedValue"
              type="number"
              onChange={this.onChange('estimatedValue')}
              value={item.estimatedValue}
            />
          </div>
          <div className="form-group col-md-5 col-sm-5">
            <PageSectionHeader>
              <FormattedMessage {...messages.currency} />
            </PageSectionHeader>
            <CurrencySelector
              onChange={this.handleCurrencyChange('currentEstimated')}
              disabled={disabled}
              value={item.currentEstimated}
            />
          </div>
        </div>
        <div className="row">
          <div className={'col-sm-6 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.haveYouReceivedReimbursement} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  type="radio"
                  value="true"
                  checked={item.haveYouReceivedReimbursement === 'true'}
                  onChange={this.onChangeResetReceived('haveYouReceivedReimbursement')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  type="radio"
                  value="false"
                  checked={item.haveYouReceivedReimbursement === 'false'}
                  onChange={this.onChange('haveYouReceivedReimbursement')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          <div className={'col-sm-6 form-group'}>
          </div>
        </div>
        {item.haveYouReceivedReimbursement === 'true' && (
          <div>
            <div className={'row ml-2'}>
              <div className="form-group col-md-7 col-sm-7">
                <PageSectionHeader>
                  <FormattedMessage {...messages.fromWhom} />
                </PageSectionHeader>
                <Textbox
                  disabled={disabled}
                  name="fromWhomReceivedReimbursement"
                  type="text"
                  onChange={this.onChange('fromWhomReceivedReimbursement')}
                  value={item.fromWhomReceivedReimbursement}
                />
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <PageSectionHeader>
                  <FormattedMessage {...messages.dateReimbursementReceived} />
                </PageSectionHeader>
                <DatePicker
                  disabled={disabled}
                  type="text"
                  onDayChange={this.handleDayChange('dateReimbursementReceived')}
                  value={item.dateReimbursementReceived}
                  placeholder="dd/mm/yyyy"
                />
              </div>
            </div>
            <div className={'row ml-2'}>
              <div className="form-group col-md-7 col-sm-7">
                <PageSectionHeader>
                  <FormattedMessage {...messages.howMuchReceivedReimbursement} />
                </PageSectionHeader>
                <Textbox
                  disabled={disabled}
                  name="howMuchReceivedReimbursement"
                  type="number"
                  onChange={this.onChange('howMuchReceivedReimbursement')}
                  value={item.howMuchReceivedReimbursement}
                />
              </div>
              <div className="form-group col-md-5 col-sm-5">
                <PageSectionHeader>
                  <FormattedMessage {...messages.currency} />
                </PageSectionHeader>
                <CurrencySelector
                  onChange={this.handleCurrencyChange('currentReceivedReimbursement')}
                  disabled={disabled}
                  value={item.currentReceivedReimbursement}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

AdditionalItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  isDelayed: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PersonalItemStep/components/Additional/AdditionalItem.js